import { render } from "./Procesos.vue?vue&type=template&id=afabdc9a&scoped=true"
import script from "./Procesos.vue?vue&type=script&lang=js"
export * from "./Procesos.vue?vue&type=script&lang=js"

import "./Procesos.vue?vue&type=style&index=0&id=afabdc9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-afabdc9a"

export default script